import { render } from "./LatestNewsSection.vue?vue&type=template&id=3b99a4e4"
import script from "./LatestNewsSection.vue?vue&type=script&lang=js"
export * from "./LatestNewsSection.vue?vue&type=script&lang=js"

import "./LatestNewsSection.vue?vue&type=style&index=0&id=3b99a4e4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__